import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService, SupportedLanguage } from '../../../core/services/i18n.service';
import { GlobalCalendarComponent } from '../global-calendar/global-calendar.component';

@Component({
    selector: 'app-language-selector',
    imports: [CommonModule],
    template: `
    <div class="language-selector flex items-center gap-1">
      <button
        (click)="changeLanguage('es')"
        class="text-sm font-semibold transition-all duration-200"
        [ngClass]="{
          'text-brand-primary': i18nService.currentLanguage() === 'es',
          'text-gray-300': i18nService.currentLanguage() !== 'es'
        }"
      >
        ESP
      </button>
      <span class="text-gray-400 text-sm font-semibold">|</span>
      <button
        (click)="changeLanguage('en')"
        class="text-sm font-semibold transition-all duration-200"
        [ngClass]="{
          'text-brand-primary': i18nService.currentLanguage() === 'en',
          'text-gray-300': i18nService.currentLanguage() !== 'en'
        }"
      >
        ENG
      </button>
    </div>
  `,
    styles: [`
    button {
      cursor: pointer;
      outline: none;
      border: none;
      background: transparent;
      padding: 0;
    }

    button:hover {
      opacity: 0.8;
    }
  `]
})
export class LanguageSelectorComponent {
  public i18nService = inject(I18nService);

  changeLanguage(lang: SupportedLanguage): void {
    this.i18nService.setLanguage(lang);
    sessionStorage.setItem('app-language-session', lang);

    window.dispatchEvent(new CustomEvent('app-lang-changed', { detail: lang }));

    GlobalCalendarComponent.setSelectedLanguage(lang);
  }
}

